<template>
  <div class="p-3">
    <div v-if="header" class="header">{{ header }}</div>
    <div class="d-flex align-items-center section-main">
      <div class="d-flex align-items-center">
        <span class="sectionTitle">{{ title }}</span>
      </div>

      <div v-if="line" class="line"></div>
    </div>

    <div class="d-flex align-items-center">
      <span class="sectionTitle">{{ subTitle }}</span>
    </div>

    <div :class="[{ sections: !backgroundClass }, { section_background_none: backgroundClass }, { 'mt-3 mb-4': extraTitle }]">
      <slot />
    </div>

    <div v-if="extraTitle">
      <div class="d-flex align-items-center mb-2">
        <span class="sectionTitle">{{ extraTitle }}</span>
      </div>

      <slot name="extra_section" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'FormSection',
  props: {
    title: {
      type: String,
    },
    subTitle: {
      type: String,
      required: false,
    },
    extraTitle: {
      type: String,
      required: false,
    },
    header: {
      type: String,
    },
    line: {
      type: Boolean,
      default: true,
    },
    backgroundClass: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.section-main {
  margin-bottom: 19.97px;
}
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.sections {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 6px;
}

.section_background_none {
  background: white;
}

.header {
  font-size: 17px;
  margin-bottom: 16px;
}
</style>
